
export const COUNTRY_LOCALE_MAP = {
  Nigeria: "en-NG",
  "United States": "en-US",
}

const getLocale = () => {
  const country = JSON.parse(localStorage.getItem("user"))?.country
  return country ? COUNTRY_LOCALE_MAP[country] : navigator.languages
}

export const formatCurrency = (amount, currency) => {
  if (!amount || !currency) {
    return
  }
  return new Intl.NumberFormat(getLocale(), {
    currency,
    style: "currency",
  }).format(amount);
};

export const getCurrency = (currency) => {
  if (!currency) {
    return
  }
  const parts = new Intl.NumberFormat(getLocale(), { style: 'currency', currency }).formatToParts(0);
  return parts.find(part => part.type === 'currency').value;
};

export const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return new Intl.DateTimeFormat(getLocale(), {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
};
